<template>
  <model-form-select
    v-bind="$attrs"
    :model="model"
    :field="field"
    label="Channels"
    :options="$mh.asOptions(channels)"
    map-options
    emit-value
    multiple
    use-chips
    clearable
    :decode="selectedChannels => $mh.objectToArray(selectedChannels)"
    :encode="enabledChannels => $mh.arrayToObject(enabledChannels || [], { allKeys: channels })"
    @update:model-value="value => $emit('update:model-value', value)"
  >
    <template #option="scope">
      <q-item
        v-bind="scope.itemProps"
        :disable="$_.includes(disabledChannels, scope.opt.value)"
        v-on="scope.itemEvents"
      >
        <q-item-section>
          <div class="column">
            <span
              class="text-body-em"
              style="font-size: 0.9rem;"
            >
              {{ scope.opt.label }}
            </span>
            <span class="text-caption">
              {{ $t(`salesChannels.tooltips.${scope.opt.value}`) }}
            </span>
          </div>
        </q-item-section>
      </q-item>
    </template>
    <q-tooltip
      anchor="top middle"
      self="bottom middle"
    >
      Available for purchase through the selected sales channels.
    </q-tooltip>
  </model-form-select>
</template>

<script>
import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'

export default {
  name: 'SalesChannelSelect',
  props: {
    model: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: false,
      default: 'salesChannels'
    },
    channels: {
      type: Array,
      required: true
    },
    disabledChannels: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  emits: ['update:model-value'],
  watch: {
    channels () {
      if (_.isNil(this.model) || this.model.loading) return

      for (const salesChannel of SALES_CHANNEL_TYPES.ALL) {
        if (this.model[this.field][salesChannel] && !_.includes(this.channels, salesChannel)) {
          this.model[this.field][salesChannel] = false
        }
      }
    },
    disabledChannels () {
      if (_.isNil(this.model) || this.model.loading) return

      for (const disabledChannel of this.disabledChannels) {
        if (this.model[this.field][disabledChannel]) {
          this.model[this.field][disabledChannel] = false
        }
      }
    }
  }
}
</script>
